<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification
                :show="filter.show"
                :type="filter.type"
                :term="filter.term"
            />
            <v-data-table
                :search="searchTerm"
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :loading="tableLoading"
            >
                <template #item.name="{ item }">
                    <v-btn
                        x-small
                        :to="'/specialty/edit/' + item.id"
                        color="primary"
                    >
                        {{ item.name }}
                        <v-icon
                            right
                            x-small
                        >
                            fas fa-edit
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.published="{ item }">
                    <v-icon
                        v-if="item.published === 1"
                        small
                        color="primary"
                    >
                        fas fa-check-circle
                    </v-icon>
                    <v-icon
                        v-else
                        small
                        color="error"
                    >
                        fas fa-minus-circle
                    </v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';

export default {
    mixins: [ItemIndexBoilerplate],

    data() {
        return {
            indexType: 'specialty',
            singularName: 'Specialty',
            pluralName: 'Starter Copy Specialties',
            responseObject: 'professions',
            headers: [
                {
                    text: 'Name',
                    value: 'name'
                }
            ]
        };
    }
};
</script>
